var Controller = require("common/Controller");
var Utils = require("common/Utils");
var postal = require("common/PubSub");

/**
 * @class
 * @param {MainTOTPView} mainTOTPView
 * @extends {Controller}
 */
function MainTOTPController(mainTOTPView) {
    Controller.call(this);

    /**
     * @override
     * @inheritDoc
     */
    this.getViews = function() {
        return [mainTOTPView];
    };

    /**
     * @override
     * @inheritsDoc
     */
    this.getId = function() {
        return "MainTOTPController";
    };

    $(document).on("userauthenticated", function() {
        // When user logs in (or refreshes) show mainTOTPView, then show TOTP view by publishing the show event to the delegate
        CudaLaunch.controllers.RootController.showView(mainTOTPView);
        postal.channel("TOTPSettingsDelegate").publish("show-totp-view");
    });
}

Utils.inherits(MainTOTPController, Controller);

module.exports = MainTOTPController;